import { useEffect } from 'react'

export const useBeforeUnload = (condition: boolean, message: string) => {
  useEffect(() => {
    const unload = (e: BeforeUnloadEvent) => {
      e.returnValue = message
      return message
    }
    if (condition) window.addEventListener('beforeunload', unload)
    return () => {
      window.removeEventListener('beforeunload', unload)
    }
  }, [condition, message])
}
